<template>
    <form class="form-horizontal" v-if="config">

        <div class="form-group">
            <label for="mbv_tensao_12_24" class="col-sm-4 control-label">TENSÃO QUE DECIDE VOLTAGEM (12 OU 24):</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.mbv_tensao_12_24" class="form-control input-sm" id="mbv_tensao_12_24">
            </div>
        </div>

        <div class="form-group">
            <label for="mbv_tensao_12" class="col-sm-4 control-label">TENSÃO DE PROTECAO 12V:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.mbv_tensao_12" class="form-control input-sm" id="mbv_tensao_12">
            </div>
        </div>

        <div class="form-group">
            <label for="mbv_tensao_24" class="col-sm-4 control-label">TENSÃO DE PROTECAO 24V:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.mbv_tensao_24" class="form-control input-sm" id="mbv_tensao_24">
            </div>
        </div>

        <div class="form-group">
            <label for="mbv_ign_alta" class="col-sm-4 control-label">IGNIÇÃO VIRTUAL ALTA:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.mbv_ign_alta" class="form-control input-sm" id="mbv_ign_alta">
            </div>
        </div>

        <div class="form-group">
            <label for="mbv_ign_baixa" class="col-sm-4 control-label">IGNIÇÃO VIRTUAL BAIXA:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.mbv_ign_baixa" class="form-control input-sm" id="mbv_ign_baixa">
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-4 col-sm-8">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Suntech} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "ServicosSuntech",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendTensao(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
